/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Center_TitleInputs */



/**
* | output |
* | --- |
* | "Align Center" |
*
* @param {Align_Center_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_center_title = /** @type {((inputs?: Align_Center_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Center_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aligner au Centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zentrieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allinea al centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выровнять по центру")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alinear al centro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("居中对齐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("中央揃え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मध्य में संरेखित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro de alinhamento")
	return /** @type {LocalizedString} */ ("Align Center")
});